import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'

export default function TextBlock({ className, children, text }) {
  return (
    <div className={clsx('text-block', className)}>
      {text}
      {children}
    </div>
  )
}

TextBlock.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  text: PropTypes.string
}
